import { Image, ImageProps } from "rebass/styled-components";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

const NewBadge = (props: ImageProps) => (
  <Image
    src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/ctas/new.svg`}
    {...props}
  />
);

export { NewBadge };
